const bundle = {
  close: () => '닫기',
  error: () => '오류',
  warn: () => '경고',
  info: () => '정보',
  confirmation: () => '확인',
  progressIndeterminate: () => '진행 중',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + '과(와) ' + p['TO_SECTION'] + ' 사이.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. 일치하는 섹션을 찾을 수 없습니다.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Enter 키를 눌러 값을 선택합니다.',
  indexer_touchInstructionText: () =>
    '길게 두번 눌러서 제스처 모드로 전환한 다음 위로 또는 아래로 드래그하여 값을 조정합니다.',
  inputPassword_show: () => '비밀번호 표시',
  inputPassword_hide: () => '비밀번호 숨기기',
  inputPassword_hidden: () => '비밀번호 숨김',
  formControl_clear: () => '지우기',
  formControl_loading: () => '로드 중',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '최대 길이 ' + p['MAX_LENGTH'] + ' 초과.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + '자 남음.',
  select_noMatchesFound: () => '일치 항목을 찾을 수 없습니다.',
  select_oneMatchFound: () => '일치하는 항목이 한 개 발견되었습니다.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '개의 일치 항목이 발견되었습니다.',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '개 이상의 일치 항목이 발견되었습니다.',
  selectMultiple_showSelectedValues: () => '선택한 값만 표시합니다.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + '개 값이 선택되었습니다.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => '체크박스 선택됨',
  selector_unselected: () => '체크박스 선택 안됨',
  userAssistance_learnMore: () => '자세히',
  userAssistance_required: () => '필수',
  filePicker_singleFileUploadError: () => '파일을 한 번에 하나씩 업로드하십시오',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    p['fileType'] + ' 유형의 파일을 업로드할 수 없습니다',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    p['fileTypes'] + ' 유형의 파일을 업로드할 수 없습니다',
  filePicker_unknownFileTypeUploadError: () => '알 수 없음',
  filePicker_dropzonePrimaryText: () => '끌어 놓기',
  filePicker_dropzoneSecondaryText: () => '파일을 선택하거나 여기에 끌어 놓기',
  filePicker_dropzoneSecondaryTextMultiple: () => '파일을 선택하거나 여기에 끌어 놓기',
  filePicker_addFiles: () => '파일 추가',
  plural_separator: () => ', ',
  inputNumber_increase: () => '늘이기',
  inputNumber_decrease: () => '줄이기',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => '표시할 항목이 없습니다',
  message_navigationFromMessagesRegion: () =>
    '메시지 영역 입력 중. F6를 눌러 이전에 포커스된 요소로 돌아갑니다.',
  message_navigationToMessagesRegion: () =>
    '메시지 영역에 새 메시지가 있습니다. F6를 눌러 가장 최근 메시지 영역으로 이동합니다.',
  messageToast_allMessagesClosed: () => '모든 토스트 메시지가 닫혔습니다.'
};
export default bundle;
